import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";
import moment from 'moment';
// Login Redux States

import { postNewActivityApi, postFilterActivityApi, changeActivityStatusApi, deleteMainActivityAPI, updateActivityStatusApi, getSellerShowingDetailApi, getBuyerShowingDetailApi, getOpenhouseShowingDetailApi, searchFilterActivityApi, postOverviewActivityApi} from "../../helpers/backend_helper"
import { ADD_NEW_ACTIVITY, CHANGE_ACTIVITY_STATUS, DELETE_ACTIVITY, GET_BUYER_SHOWING_DETAIL, GET_OPENHOUSE_SHOWING_DETAIL, GET_SELLER_SHOWING_DETAIL, POST_ACTIVITY_FILTER, POST_ACTIVITY_OVERVIEW, SEARCH_ACTIVITY_FILTER, UPDATE_ACTIVITY_FILTER } from "./actionTypes";
import { addNewActivityError, addNewActivitySuccess, changeActivityStatusError, changeActivityStatusSuccess, deleteMainActivityFail, deleteMainActivitySuccess, getBuyerShowingDetailFail, getBuyerShowingDetailSuccess, getOpenhouseShowingDetailFail, getOpenhouseShowingDetailSuccess, getSellerShowingDetailFail, getSellerShowingDetailSuccess, postActivityFilterError, postActivityFilterSuccess, postActivityOverviewFilterError, postActivityOverviewFilterSuccess, searchActivityFilterError, searchActivityFilterSuccess } from "./actions";
import { post } from "jquery";
function* addNewActivity({ payload: { activity, callback } }) {

  try {
        toast.loading("Please wait...")
        const response  = yield call(postNewActivityApi, activity)
        if(response.success){
        toast.dismiss();
        toast.success("Saved successfully");
        yield put(addNewActivitySuccess(response))
        const today = moment().startOf('day');
        const requestData = {
          activityTypeId: [0],
          activityFromDate: today.toISOString(),
          activityToDate: today.endOf('day').toISOString(),
          agentId: parseInt(localStorage.getItem("userId"))
        };
        const res  = yield call(postFilterActivityApi, requestData)
        yield put(postActivityFilterSuccess(res))
        if(callback){
          callback(true);
        }
        }else{
            toast.dismiss();
            toast.warn(response.validationErrors[0] || 'some error please try after some time');
            if(callback){
                callback(false);
            }
          
        }
    }
  catch (error) {
       
      yield put(addNewActivityError('Some Error'))
      if(callback){
                callback(false);
      }
  }
}


function* postNewActivityFilter({ payload: filter }) {
 // 
  try {
        const response  = yield call(postFilterActivityApi, filter)
        yield put(postActivityFilterSuccess(response))
    }
  catch (error) {
       
      yield put(postActivityFilterError('Some Error'))
  }
}


function* postNewActivityOverView({ payload: filter }) {
  // 
   try {
         const response  = yield call(postOverviewActivityApi, filter)
         yield put(postActivityOverviewFilterSuccess(response))
     }
   catch (error) {
        
       yield put(postActivityOverviewFilterError('Some Error'))
   }
 }

function* postChangeStatus({ payload: activity }) {

  try {
        const response  = yield call(changeActivityStatusApi, activity)
        //yield put(changeActivityStatusSuccess(response))
        const today = moment().startOf('day');
        const requestData = {
          activityTypeId: [0],
          activityFromDate: today.toISOString(),
          activityToDate: today.endOf('day').toISOString(),
          agentId: parseInt(localStorage.getItem("userId"))
        };
        const res  = yield call(postFilterActivityApi, requestData)
        yield put(postActivityFilterSuccess(res))
    }
  catch (error) {
       
      yield put(changeActivityStatusError('Some Error'))
  }
}

function* onDeleteAppLocationType({ payload: activity }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteMainActivityAPI, activity.id, activity.activityType)
    yield put(deleteMainActivitySuccess(response))
    toast.dismiss();
    toast.success("Activity Deleted")

  } catch (error) {
    yield put(deleteMainActivityFail(error))
  }
}

function* onUpdateMailActivity({ payload: activity, callback }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateActivityStatusApi, activity)
    if(response.success){
    toast.dismiss();
    toast.success("Updated successfully");
    const today = moment().startOf('day');
    const requestData = {
          activityTypeId: [0],
          activityFromDate: (activity.fromDate) ? moment(activity.fromDate).format('YYYY-MM-DD') : today.toISOString(),
          activityToDate:  (activity.toDate) ? moment(activity.toDate).format('YYYY-MM-DD') : today.endOf('day').toISOString(),
          agentId: parseInt(localStorage.getItem("userId"))
        };
    const res  = yield call(postFilterActivityApi, requestData)
    yield put(postActivityFilterSuccess(res))
    if(callback){
          callback(true);
      }
      }else{
        toast.dismiss();
        toast.warn(response.validationErrors[0] || 'some error please try after some time');
        if(callback){
          callback(false);
      }
      }
  } catch (error) {
    yield put(updateAppLocationTypeFail(error))
     if(callback){
          callback(false);
      }
  }
}

function* fetchSellerShowingDetail({ sellerShowingId }) {
  try {
    const response = yield call(getSellerShowingDetailApi, sellerShowingId)
    yield put(getSellerShowingDetailSuccess(response))
  } catch (error) {
    yield put(getSellerShowingDetailFail(error))
  }
}

function* fetchBuyerShowingDetail({ buyerShowingId }) {
  try {
    const response = yield call(getBuyerShowingDetailApi, buyerShowingId)
    yield put(getBuyerShowingDetailSuccess(response))
  } catch (error) {
    yield put(getBuyerShowingDetailFail(error))
  }
}


function* fetchOpenhouseShowingDetail({ openhouseId }) {
  try {
    const response = yield call(getOpenhouseShowingDetailApi, openhouseId)
    yield put(getOpenhouseShowingDetailSuccess(response))
  } catch (error) {
    yield put(getOpenhouseShowingDetailFail(error))
  }
}

function* searchNewActivityFilter({ payload: filter }) {
  // 
   try {
         const response  = yield call(searchFilterActivityApi, filter)
         yield put(searchActivityFilterSuccess(response))
     }
   catch (error) {
        
       yield put(searchActivityFilterError('Some Error'))
   }
 }

function* activitySaga() {
  yield takeEvery(ADD_NEW_ACTIVITY, addNewActivity)
  yield takeEvery(POST_ACTIVITY_FILTER, postNewActivityFilter)
  yield takeEvery(POST_ACTIVITY_OVERVIEW, postNewActivityOverView)
  yield takeEvery(SEARCH_ACTIVITY_FILTER, searchNewActivityFilter)
  yield takeEvery(CHANGE_ACTIVITY_STATUS, postChangeStatus)
  yield takeEvery(DELETE_ACTIVITY, onDeleteAppLocationType)
  yield takeEvery(UPDATE_ACTIVITY_FILTER, onUpdateMailActivity)
  yield takeEvery(GET_SELLER_SHOWING_DETAIL, fetchSellerShowingDetail)
  yield takeEvery(GET_BUYER_SHOWING_DETAIL, fetchBuyerShowingDetail)
  yield takeEvery(GET_OPENHOUSE_SHOWING_DETAIL, fetchOpenhouseShowingDetail)

}

export default activitySaga
